import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions.js';
import mutations from './mutations.js';

// Dev Only
import { industryOptions } from '../fixtures/industry-options.js';
import { sectorOptions } from '../fixtures/sector-options.js';
import { categoryOptions } from '../fixtures/category-options.js';
import { bicsTv } from '../fixtures/bics-tv.js';
import { bics } from '../fixtures/bics.js';

Vue.use(Vuex)

export const initialState = {
  mode: 'default', // default|browse|search
  term: '',
  helpForSearchTerm: null, // comes from the API when too many results are returned
  loading: false,
  messageType: null, // error|success
  message: null, 
  bics: [],
  bicsSelected: [], // Selected Bics need to persist during the session so we need to store the whole object, not just the code
                       // format: { 555c7ba77aaceec91e3f2be1: { code: 'A052927', desc: 'xyz', ... }}
  alternateBicSource: null, // Other codes to consider - original code
  alternateBic: null, // Other codes to consider - Bic info to show in place of original Bic
  alternateBicLoading: false, // Other codes to consider - boolean - fetching data
  showSelected: false, // boolean - in the store as we want to control and use it as global level (url, toolbar, bilList)
  // displayList: false, // boolean - true for list, false for grid
  displayList: false,
  bicsHelp: null, // code|null - in the store as we want to control it as global level, not bic item level
  // Industry
  industry: null,
  industryOptions: [],
  industryLoading: false,
  // Sector
  sector: null,
  sectorOptions: [],
  sectorLoading: false,
  // Category
  category: null,
  categoryOptions: [],
  categoryLoading: false,
};

// Dev Only
export const initialStateSearch = {
  ...initialState,
  mode: 'search',
  ...bics,
  industryOptions
};

// Dev Only
export const initialStateBrowse = {
  ...initialState,
  mode: 'browse',
  bics: bicsTv,
  bicsSelected: ['J562120'],
  alternateBicSource: 'J562120', // Other codes to consider - original code
  alternateBic: { ...bics.bics[0] }, // Other codes to consider - Bic info to show in place of original Bic
  industry: '555bb0e425a9732ca20a3355',
  sector: '555c6bd38af667b6bbf11197',
  category: '555bc5e225a9732ca20a1151',
  sectorOptions,
  industryOptions,
  categoryOptions,
};

export default new Vuex.Store({
  state: { ...initialState },
  mutations,
  actions,
  getters: {
    // implement this getter to watch the value in the App component and trigger a save into localStorage on change
    getBicsSelected: state => {
      return state.bicsSelected;
    }
  }
});